import * as Types from '../../__generated__/types';

import { gql } from '@apollo/client';
export type MediaFileFragment = { __typename?: 'File', id: string, type: Types.FileType, name?: string | null, url: string, blurhash?: string | null, thumbnailUrl?: string | null, thumbnailBlurhash?: string | null };

export const MediaFileFragmentDoc = gql`
    fragment MediaFile on File {
  id
  type
  name
  url
  blurhash
  thumbnailUrl
  thumbnailBlurhash
}
    `;